export default "/_next/static/images/c90a8621d863a4ad2631ec11e8e0be24.jpg";